<lib-ph-bhp-sop-statical-evaluation [filterDetails]="config.filterDetails" (childData)=onChildData($event)></lib-ph-bhp-sop-statical-evaluation>